import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createRequests from '../../common/services/create-requests';
import commonReducers from '../../common/reducers';
import blogStatsReducer from '../../common/store/blog-stats/blog-stats-reducer';
import categoryMenuWidgetReducer from '../aggregated-category-menu/reducer';

export function createReduxStore({ appParams, wixCodeApi, compId, fedopsLogger, bundleName }) {
  const p = {};

  const { request, platformizedRequest, aggregatorRequest } = createRequests({
    appParams,
    wixCodeApi,
    bundleName,
    getStore: () => p.store,
  });

  const middleware = [
    thunk.withExtraArgument({
      request,
      platformizedRequest,
      aggregatorRequest,
      wixCodeApi,
      compId,
      appParams,
      fedopsLogger,
    }),
  ];

  const reducers = combineReducers({
    ...commonReducers,
    blogStats: blogStatsReducer,
    categoryMenuWidget: categoryMenuWidgetReducer,
  });

  p.store = createStore(reducers, undefined, applyMiddleware(...middleware));

  return p.store;
}
